export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6091.6d46731e.jpg";